import { createSelector } from '@reduxjs/toolkit';
import { selectReportSettings } from '../../store/selectors';

export const selectAfsls = createSelector(selectReportSettings, (settings) => settings.afsls);

export const selectAfslId = createSelector(selectReportSettings, (settings) => settings.afslId);

export const selectAssetClassOrderItems = createSelector(selectReportSettings, (settings) => settings.assetClassOrderItems);
